/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import {connect} from "react-redux";
import _ from "lodash";
import "./audio.css";
import {login, listArtworks} from "./Redux/actions/user";
import {Redirect} from "react-router-dom";

import Select from "react-select";
import {SERVER} from "./Redux/actions/actionType";
const options = [
  {value: "", label: "Toutes"},
  {value: "compas", label: "Compas"},
  {value: "vodou", label: "Vodou"},
  {value: "raboday", label: "Raboday"},
  {value: "rnb", label: "RNB"},
  {value: "afro", label: "Afro"},
  {value: "raggae", label: "Raggae"},
  {value: "arts visuels", label: "Arts visuels"},
  {value: "litteraires", label: "littéraires"},
  {value: "arts du spectacle", label: "Arts du spectacle"},
];

const filtre = (arr, artwork, artist) => {
  return arr
    .filter((d) =>
      JSON.stringify(d.type).toLowerCase().includes(artwork.toLowerCase())
    )
    .filter((d) =>
      JSON.stringify(d.users).toLowerCase().includes(artist.toLowerCase())
    );
};
class App extends Component {
  componentWillMount() {
    //this.loadBlockchainData();
  }

  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      selected: [],
      authors: [],
      artwork: "",
      artist: "",
      search: "",
      category: "",
      loading: false,
    };

    this.props.listArtworks();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.user !== prevProps.user) {
      window.location.reload();
    }
  }

  componentDidMount() {
    let self = this;
    // axios.get(`${SERVER}/artworks`).then(function (response) {
    //   console.log(response);
    //   self.setState({datas: response.data});
    // });

    axios
      .get(`${SERVER}/users`)
      .then(function (response) {
        console.log(response.data);
        self.setState({
          authors: response.data.filter((a) => a.role_user !== "admin"),
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <main class="page-wrapper" style={{padding: 20}}>
        <div class="rn-portfolio-area rn-section-gap bg_color--1 ">
          <div class="container " style={{marginTop: 100}}>
            <div class="col-lg-12">
              <div class="section-title text-center mb--20 mb_sm--0">
                <h2 class="title">VILAJ MARKET</h2>
                <p style={{color: "#aaa"}}>
                  {
                    "Espace dédié à la vente des oeuvres qui ont été enregistrées et certifiées par VILAJ et BHDA. \n"
                  }
                </p>
                <br />

                {this.state.category !== "" ? (
                  <a
                    style={{color: "blue", cursor: "pointer"}}
                    onClick={() => this.setState({category: ""})}>
                    Toutes les categories
                  </a>
                ) : null}
              </div>
            </div>
            <br />
            <br />

            {this.state.category === "" ? (
              <div className="row">
                <div class="col-md-5">
                  <h3 class="title">Sons et musiques</h3>
                  <p>Beats, musique, instrumental et autres composants</p>
                </div>
                <div class="col-md-2 offset-5">
                  <a
                    style={{float: "right", color: "blue", cursor: "pointer"}}
                    onClick={() => this.setState({category: "musique"})}>
                    Voir plus
                  </a>
                </div>
                {this.props.artworks
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  .sort(function (a, b) {
                    if (a.name < b.name) {
                      return -1;
                    }
                    if (a.name > b.name) {
                      return 1;
                    }
                    return 0;
                  })
                  .filter((a) => a.users[0].type.value === "musique").length >
                0 ? (
                  <div className="row">
                    {this.props.artworks
                      .filter((a) => a.users[0].type.value === "musique")
                      .sort(function (a, b) {
                        if (a.name < b.name) {
                          return -1;
                        }
                        if (a.name > b.name) {
                          return 1;
                        }
                        return 0;
                      })
                      .map((task, key) => {
                        if (key < 3) {
                          return (
                            <div
                              className="col-lg-4 col-md-6 col-sm-12"
                              style={{minWidth: 370}}
                              key={key}>
                              <span
                                style={{
                                  marginLeft: 20,
                                  fontSize: 20,
                                  fontWeight: "bold",
                                  position: "absolute",
                                  color: "#fff",
                                  bottom: 10,
                                  right: 30,
                                  zIndex: 999,
                                }}>
                                {"99.99 G"}
                              </span>
                              <div className="blog blog-style--1">
                                <div className="">
                                  <a href="blog-details.html">
                                    <img
                                      style={{height: 300, objectFit: "cover"}}
                                      className="w-100"
                                      src={`https://ipfs.infura.io/ipfs/${task.files[0].id}`}
                                      alt="Blog Images"
                                    />
                                  </a>
                                </div>
                                <div className="content">
                                  <p className="blogtype">
                                    {" "}
                                    {task.type.value.toUpperCase()}
                                  </p>
                                  <h4 className="title">
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        fontSize: 17,
                                      }}>
                                      {task.name}
                                    </a>
                                  </h4>
                                  {task.type.value.toUpperCase() !==
                                  "Arts visuels".toUpperCase() ? (
                                    <div className="blog-btn">
                                      <div className="blog-btn">
                                        <a
                                          style={{cursor: "pointer"}}
                                          className="rn-btn text-white"
                                          data-toggle="modal"
                                          data-target=".bd-example-modal-lg"
                                          onClick={() => {
                                            this.setState(
                                              {selected: task},
                                              () => {
                                                PauseAudio();
                                              }
                                            );
                                          }}>
                                          Voir plus
                                        </a>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="blog-btn">
                                      <a
                                        style={{cursor: "pointer"}}
                                        className="rn-btn text-white"
                                        data-toggle="modal"
                                        data-target=".bd-example-modal-lg"
                                        onClick={() => {
                                          this.setState({selected: task});
                                        }}>
                                        Voir plus
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                  </div>
                ) : (
                  <div style={{height: 200}} />
                )}
                <br /> <br />
              </div>
            ) : null}
            {this.state.category === "" ? (
              <div className="row">
                <div class="col-md-5">
                  <h3 class="title">Arts</h3>
                  <p>Tableaux, artisanats, sculpture, etc...</p>
                </div>
                <div class="col-md-2 offset-5">
                  <a
                    style={{float: "right", color: "blue", cursor: "pointer"}}
                    onClick={() => this.setState({category: "artistique"})}>
                    Voir plus
                  </a>
                </div>
                {this.props.artworks.filter(
                  (a) => a.users[0].type.value === "artistique"
                ).length > 0 ? (
                  <div className="row">
                    {this.props.artworks
                      .sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                      )
                      .filter((a) => a.users[0].type.value === "artistique")
                      .map((task, key) => {
                        if (key < 3) {
                          return (
                            <div
                              className="col-lg-4 col-md-6 col-sm-12"
                              style={{minWidth: 370}}
                              key={key}>
                              <span
                                style={{
                                  marginLeft: 20,
                                  fontSize: 20,
                                  fontWeight: "bold",
                                  position: "absolute",
                                  color: "#fff",
                                  bottom: 10,
                                  right: 30,
                                  zIndex: 999,
                                }}>
                                {"99.99 G"}
                              </span>
                              <div className="blog blog-style--1">
                                <div className="">
                                  <a>
                                    <img
                                      style={{height: 300, objectFit: "cover"}}
                                      className="w-100"
                                      src={`https://ipfs.infura.io/ipfs/${task.files[0].id}`}
                                      alt="Blog Images"
                                    />
                                  </a>
                                </div>
                                <div className="content">
                                  <p className="blogtype">
                                    {" "}
                                    {task.type.value.toUpperCase()}
                                  </p>
                                  <h4 className="title">
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        fontSize: 17,
                                      }}>
                                      {task.name}
                                    </a>
                                  </h4>
                                  {task.type.value.toUpperCase() !==
                                  "Arts visuels".toUpperCase() ? (
                                    <div className="blog-btn">
                                      <div className="blog-btn">
                                        <a
                                          style={{cursor: "pointer"}}
                                          className="rn-btn text-white"
                                          data-toggle="modal"
                                          data-target=".bd-example-modal-lg"
                                          onClick={() => {
                                            this.setState({selected: task});
                                          }}>
                                          Voir plus
                                        </a>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="blog-btn">
                                      <a
                                        style={{cursor: "pointer"}}
                                        className="rn-btn text-white"
                                        data-toggle="modal"
                                        data-target=".bd-example-modal-lg"
                                        onClick={() => {
                                          this.setState({selected: task});
                                        }}>
                                        Voir plus
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                  </div>
                ) : (
                  <div style={{height: 200}} />
                )}
                <br /> <br />
              </div>
            ) : null}

            {this.state.category !== "" ? (
              <Market
                artworks={this.props.artworks}
                category={this.state.category}
              />
            ) : null}
          </div>
        </div>
        <Modal selected={this.state.selected} />
        <div
          className="modal fade"
          id="loginModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="loginModalLabel"
          aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Connectez-vous
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label htmlFor="recipient-name" className="col-form-label">
                      Email ou Nom d'artiste:
                    </label>
                    <input
                      id="email"
                      ref={(input) => {
                        this.email = input;
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message-text" className="col-form-label">
                      Mot de passe:
                    </label>
                    <input
                      type="password"
                      id="pass"
                      ref={(input) => {
                        this.password = input;
                      }}
                      className="form-control"
                      placeholder="Password"
                      required
                    />
                  </div>
                  {this.state.loading === true ? (
                    <center>
                      <p style={{fontSize: 12}}>Connection en cours...</p>
                    </center>
                  ) : null}
                </form>
              </div>
              {this.state.loading === false ? (
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal">
                    Fermer
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      // Request API.
                      this.setState({loading: true});
                      setTimeout(() => {
                        alert("Problème de connection avec le serveur");
                        this.setState({loading: false});
                      }, 15000);
                      this.props.login({
                        identifier: this.email.value,
                        password: this.password.value,
                      });
                    }}>
                    Connectez-vous
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </main>
    );
  }
}

class Market extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: this.props.datas,
      selected: [],
      authors: [],
      artwork: "",
      artist: "",
      search: "",
    };
  }

  componentDidMount() {
    let self = this;
    axios.get(`${SERVER}/artworks`).then(function (response) {
      console.log(response);
      self.setState({datas: response.data});
    });

    axios
      .get(`${SERVER}/users`)
      .then(function (response) {
        console.log(response.data);
        self.setState({
          authors: response.data.filter((a) => a.role_user !== "admin"),
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  render() {
    return (
      <div class="row">
        <div class="container" style={{position: "relative", zIndex: 999}}>
          <div class="row">
            <div class="col-sm">
              <Select
                isSearchable
                placeholder={"Auteurs"}
                style={{zIndex: 999}}
                options={_.concat(
                  [{value: "", label: "Touts"}],
                  this.state.authors.map((a) => {
                    return {value: a.username, label: a.username};
                  })
                )}
                onChange={(input) => {
                  console.log(input);
                  this.setState({artist: input.value});
                }}
              />
              <br />
            </div>
            <div class="col-sm">
              <Select
                isSearchable
                placeholder={"Categories"}
                options={options}
                onChange={(input) => {
                  this.setState({artwork: input.value});
                }}
              />
              <br />
            </div>
            <div class="col-sm">
              <input
                style={{height: 55}}
                id="recherche"
                onChange={(input) => {
                  this.setState({search: input.target.value});
                }}
                type="text"
                className="form-control"
                placeholder="Recherche"
                required
              />{" "}
              <br />
            </div>
          </div>
        </div>
        {filtre(
          this.props.artworks.filter(
            (f) => f.users[0].type.value === this.props.category
          ),
          this.state.artwork,
          this.state.artist
        ).filter((a) =>
          JSON.stringify(a).toLowerCase().includes(this.state.search)
        ).length > 0 ? (
          <div className="row">
            {filtre(
              this.props.artworks
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .filter((f) => f.users[0].type.value === this.props.category),
              this.state.artwork,
              this.state.artist
            )
              .sort(function (a, b) {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              })
              .filter((a) =>
                JSON.stringify(a).toLowerCase().includes(this.state.search)
              )
              .map((task, key) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-126"
                  style={{minWidth: 370}}
                  key={key}>
                  <span
                    style={{
                      marginLeft: 20,

                      fontSize: 20,
                      fontWeight: "bold",
                      position: "absolute",
                      color: "#fff",
                      bottom: 10,
                      right: 30,
                      zIndex: 999,
                    }}>
                    {"99.99 G"}
                  </span>
                  <div className="blog blog-style--1">
                    <div className="">
                      <a>
                        <img
                          style={{height: 300, objectFit: "cover"}}
                          className="w-100"
                          src={`https://ipfs.infura.io/ipfs/${task.files[0].id}`}
                          alt="Blog Images"
                        />
                      </a>
                    </div>
                    <div className="content">
                      <p className="blogtype">
                        {" "}
                        {task.type.value.toUpperCase()}
                      </p>
                      <h4 className="title">
                        <a style={{textDecoration: "none", fontSize: 17}}>
                          {task.name}
                        </a>
                      </h4>

                      {task.type.value.toUpperCase() !==
                      "Arts visuels".toUpperCase() ? (
                        <div className="blog-btn">
                          <div className="blog-btn">
                            <a
                              style={{cursor: "pointer"}}
                              className="rn-btn text-white"
                              data-toggle="modal"
                              data-target=".bd-example-modal-lg"
                              onClick={() => {
                                this.setState({selected: task}, () => {
                                  PauseAudio();
                                });
                              }}>
                              Voir plus
                            </a>
                          </div>
                        </div>
                      ) : (
                        <div className="blog-btn">
                          <a
                            style={{cursor: "pointer"}}
                            className="rn-btn text-white"
                            data-toggle="modal"
                            data-target=".bd-example-modal-lg"
                            onClick={() => {
                              this.setState({selected: task});
                            }}>
                            Voir plus
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div style={{height: 500}} />
        )}

        <Modal selected={this.state.selected} />
      </div>
    );
  }
}

class Modal extends Component {
  render() {
    return (
      <div
        class="modal fade bd-example-modal-lg"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Details
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              {this.props.selected && this.props.selected.name ? (
                <div class="music-player">
                  <div class="player-main">
                    <div class="main-current">
                      <div class="current-keyvisual">
                        <img
                          src={`https://ipfs.infura.io/ipfs/${this.props.selected.files[0].id}`}
                        />
                      </div>
                      <div class="current-info">
                        <h1> {this.props.selected.name}</h1>
                        <p> {this.props.selected.users[0].username}</p>
                        {/* <h6> {this.props.selected.users[0].username}</h6> */}

                        {this.props.selected.files &&
                        this.props.selected.files[1] ? (
                          <audio
                            id="music"
                            preload="true"
                            oncontextmenu="return false;"
                            controls
                            controlsList="nodownload"
                            style={{
                              marginTop: 0,
                              width: 260,
                              marginRight: 0,
                            }}>
                            <source
                              src={`https://ipfs.infura.io/ipfs/${this.props.selected.files[1].id}`}
                              type={this.props.selected.files[1].type}
                            />
                            Your browser does not support the audio element.
                          </audio>
                        ) : null}
                      </div>
                      <a
                        href="https://moncash-api.herokuapp.com?amount=99.99&orderId=13242343244"
                        target="popup"
                        onClick={() => {
                          window.open(
                            "https://moncash-api.herokuapp.com?amount=99.99&orderId=13242343244",
                            "popup",
                            "width=300,height=500"
                          );
                          return false;
                        }}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: 25,
                          right: 20,
                        }}
                        className="rn-button-style--2 btn_solid">
                        Acheter
                      </a>
                    </div>
                    <ul class="player-list">
                      <div className="row">
                        <div className="col-lg-3  col-sm-12">
                          {this.props.selected.collaborators.map((aut, key) => (
                            <li>
                              <img
                                class="list-cover"
                                src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/329679/music-player-freebie-a1.png"
                              />
                              <div class="list-info">
                                <div class="info-title">{aut.fullname}</div>
                                <div class="info-artist">
                                  {aut.nature.substring(0, 9) + "."}
                                  {aut.percent ? " - " + aut.percent + "%" : ""}
                                </div>
                              </div>
                            </li>
                          ))}
                        </div>
                        <div className="col-lg-9 col-sm-12">
                          <h5 style={{marginTop: 10}}>
                            Termes et conditions d'utilisation
                          </h5>
                          <p
                            style={{
                              fontSize: 12,
                              lineHeight: 1.2,
                              color: "#aaa",
                            }}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip
                            ex ea commodo consequat. Duis aute irure dolor ...
                          </p>
                          <span
                            style={{
                              fontSize: 12,
                              color: "blue",
                              cursor: "pointer",
                            }}>
                            Plus de details
                          </span>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function PlayAudio() {
  var audio = document.getElementById("music");

  audio.play();
}

function PauseAudio() {
  var audio = document.getElementById("music");

  audio.pause();
  audio.load();
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    artworks: state.user.artworks,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => {
      dispatch(login(data));
    },
    listArtworks: () => {
      dispatch(listArtworks());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
